<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card v-if="disposer">
      <v-card-title>処分方法</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              名称
            </div>
            <h4>{{ disposer.name }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              コード
            </div>
            <h4>{{ disposer.code }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              並び順
            </div>
            <h4>{{ disposer.position }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              データ作成日時
            </div>
            <h4>{{ disposer.created_at | unix_datetime_format }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              データ更新日時
            </div>
            <h4>{{ disposer.updated_at | unix_datetime_format }}</h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="error"
          @click="deleteButtonClickEvent"
        >
          削除
        </v-btn>
        <v-spacer />
        <v-btn
          color="info"
          @click="editButtonClickEvent"
        >
          編集
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import Confirm from '../../../../components/Confirm'
export default {
  name: 'AdminMasterDisposerShow',
  components: { Confirm },
  mixins: [],
  data () {
    return {
      breadcrumbs: [
        { text: '処分方法一覧', disabled: false, to: '/admin/masters/disposers', exact: true },
        { text: '処分方法詳細', disabled: true, to: '' },
      ],
      disposer: null,
    }
  },
  created() {
    this.disposer = {
      id: 1,
      code: '100',
      name: '再生',
      position: 1,
      created_at: 1633314402,
      updated_at: 1633314402,
    }
  },
  methods: {
    editButtonClickEvent () {
      this.$router.push({name: 'AdminMasterDisposerEdit', params: {id: this.disposer.id}})
    },
    deleteButtonClickEvent () {
      let modalOption = { title: '削除', message: '処分方法を削除します。よろしいですか？', options: { titleColor: 'red' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.$router.push({name: 'AdminMasterdisposers'})
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
